"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containsAny = exports.length = void 0;
/**
 *
 * @deprecated For arrays, use `.size()`, and for strings, use `.length()`
 *
 * @warning On the backend, this does not handle strings.
 * #length("abc") // 1
 * whereas on the frontend
 * #length("abc") // 3
 */
function length(array) {
    return array.length;
}
exports.length = length;
/**
 *
 * @warning On the backend, this does not work nicely with strings. For example
 * #containsAny("abc", "a") // false
 * whereas on the frontend it will return true.
 *
 * @param arr1 The array to search
 * @param arr2 The array of items to search for.
 * @returns true if any of the items in arr2 are found in arr1.
 */
function containsAny(arr1, arr2) {
    if (!arr1 || !arr2) {
        return false;
    }
    return (typeof arr1 === 'string' ? arr1.split('') : arr1).some(function (r) { return arr2.indexOf(r) >= 0; });
}
exports.containsAny = containsAny;
//# sourceMappingURL=array.js.map